<template>
	<div id="usualNewReturn">
		<el-col>
			<div class="form-item-flex fl" style="width:50%;margin-top:-62px;margin-left:330px">
				<el-input  clearable @input="inputSerialComform" style="width:30%;margin-right:20px" v-model.trim="returnForm.number" :autofocus="true" placeholder="请输入或扫描序列号"></el-input>
				<el-button type="primary" size="medium" @click="addSerialComformBtn" style="margin-bottom: 15px;">确认</el-button>
				<div class="totalDiv" style="position:absolute;right:40px;top:60px;">
					<small>数量：</small>
					<strong >{{returnData.length}}</strong> &nbsp;&nbsp;&nbsp;&nbsp;
					<span v-if="returnForm.returnType == 2">
						<small >总计：</small>
						<strong >{{totalMoney}}</strong> 元
					</span>
				</div>
				<i class="el-icon-refresh" style="position: absolute;top:20px;right:20px;font-size: 25px;cursor: pointer;" @click="refresh()"></i>
			</div>
			<el-table
				:data="returnData"
				border
				ref="multipleTable"
				:header-cell-style="{'text-align':'center'}"
				style="width: 100%"
				@selection-change="handleSelectionChange"
				@row-click="handleCurrentChange"
				:default-sort="{prop:'index',order:'descending'}"
				>
				<el-table-column
                    align="center"
                    type="selection"
                    width="55">
                </el-table-column>
				<!-- <el-table-column
					align="center"
					type="index"
					width="50"
					label="序号">
				</el-table-column> -->
				<el-table-column
					align="center"
					prop="code"
					width="100"
					label="序列号">
				</el-table-column>
				<el-table-column
					align="center"
					width="200"
					label="品牌品类型号">
					<template slot-scope="scope">
					   	{{scope.row.brandName}} {{scope.row.categoryName}} {{scope.row.modelName}}
					</template>
				</el-table-column>
				<el-table-column
					align="center"
					prop="materialName"
					width="150"
					label="物料名称">
				</el-table-column>
				<el-table-column
					align="center"
					prop="orderNo"
					width="100"
					label="关联订单号">
				</el-table-column>
				<el-table-column
					align="center"
					prop="maintainPrice"
					width="100"
					label="维修金额">
				</el-table-column>
				<el-table-column
					align="center"
					prop="warehouseType"
					width="100"
					label="仓库类型">
					<template slot-scope="scope">
						{{scope.row.warehouseType | sysCodeFileter('warehouse_type')}}
					</template>
				</el-table-column>
				<el-table-column
					align="center"
					prop="materialName"
					width="150"
					label="领用时间">
					<template slot-scope="scope">
						<span v-if="scope.row.pickTime">{{scope.row.pickTime | date}}</span>
					</template>
				</el-table-column>
				<el-table-column
					align="center"
					prop="engineerName"
					width="100"
					label="退料人">
				</el-table-column>
				<el-table-column
					align="center"
					prop="materialName"
					width="100"
					label="客户自留">
					<template slot-scope="scope">
						<el-select v-model="scope.row.isRetenRetain" style="width: 100%;">
	                        <el-option v-for="(item,index) in pickingMatain"
	                            :label="item.paraName"
	                            :value="item.paraValue"
	                            :key="index">
	                        </el-option>
	                    </el-select>
					</template>
				</el-table-column>
				<el-table-column
					align="center"
					label="操作">
					<template slot-scope="scope">
						<el-button @click.stop="deleteRow(scope.$index, returnData)" type="text" size="small">移除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" @click.native="DetermineSave()">提交</el-button>
			<el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" @click.native="DetermineSave2()">暂存</el-button>
			<el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" @click.native="DetermineSave1()">良品入废品</el-button>
			<el-dropdown split-button type="primary" trigger="click" class="fr" style="margin: 50px 20px 50px 0;">
				{{pageStatus}}
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item @click.native="goOnSave()">留在当前页面</el-dropdown-item>
					<el-dropdown-item @click.native="closeSave()">离开当前页面</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
			<el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" @click="cancelOrder()">取消新建</el-button>
		</el-col>
	</div>
</template>

<script>
  import {hideLoading, showLoading} from "../loading/loading";

  let moment = require("moment");
	import clip from '@/util/clipboard'
	import {
		wasteTreasureType,
		queryMaterialBySerialNumber,
		addReturnMaterial,
		returnMaterialSave,
		selectParameterInfoBusiness
	} from "../../api/api";
	export default {
		name: 'usualNewReturn',
		props: {
			returnForm: {
			   type: Object
			}
		},
		data () {
			return {
				totalMoney:0,//总金额
				pageStatus:'留在当前页面',
				labelPosition:'left',
				returnData: [],
				pickingMatain:[
					{
						paraName:'否',
						paraValue:0
					},
					{
						paraName:'自留',
						paraValue:1
					},
					{
						paraName:'保留',
						paraValue:2
					}
				],
				multipleSelection:[]
			}
		},
		created(){
		},
		methods: {
			handleCurrentChange(row, event, column){
				let isHave = false;
				this.multipleSelection.forEach((item,index)=>{
					if(row.code === item.code){
						isHave = true
					}
				})
				isHave ? this.$refs.multipleTable.toggleRowSelection(row,false) : this.$refs.multipleTable.toggleRowSelection(row,true);
			},
			//获取选中型号的物料数据 => 数组
            handleSelectionChange(val) {
                if(val != []){
                    this.multipleSelection = val;
                }
            },
			//移除订单
			deleteRow(index, rows) {
				if(rows.length > 0){
					if(this.returnForm.returnType == 2){
						this.totalMoney = this.totalMoney - Number(rows[index].amount)
					}
				}else{
					this.totalMoney = 0
				}
				rows.splice(index, 1);
			},
			// 汇总数量和金额
			getAllMoney() {
				this.totalMoney = 0
				if (this.returnData) {
					this.returnData.forEach(element => {
						this.totalMoney = this.totalMoney + element.price * element.count
					})
				}
			},
			//查询序列号物料信息
			queryBySerialNumberData(){
				let isReplace = false
				if(this.returnForm.number.length == 8){
					this.returnData.forEach((item,index)=>{
						if(item.code == this.returnForm.number){
							this.$message({
								message: '当前序列号已添加至列表，请重新输入',
								type: "warning"
							});
							isReplace = true
						}
					})
					if(!isReplace){
						let para = {
							number:this.returnForm.number,
							affiliationType:1,
							queryType:1,
						}
						queryMaterialBySerialNumber(para).then(res => {
							if (res.data.status==100) {
								if(res.data.results.length > 0){
									res.data.results[0].isRetenRetain = 0;
									let isHave = false;
									if(this.returnData.length > 0){
										this.returnData.forEach((item,index)=>{
											if(item.code == res.data.results[0].code){
												isHave = true
											}
										})
										if(!isHave){
											this.returnData.unshift(res.data.results[0]);
										}
									}else{
										this.returnData.unshift(res.data.results[0]);
									}
								}else{
									this.$message({
										message: '您输入的序列号有误，请重新输入',
										type: "warning"
									});
								}
								this.returnForm.number = "";
							}else{
								this.$message({
									message: res.data.message,
									type: "error"
								});
							}
						}).catch((error) =>{
							this.$Message.error(error.message);
						})
					}
				}
			},
			//提交添加序列号
			addSerialComformBtn(){
				if(!this.returnForm.returnType){
					this.$message({
						message: '请选择退料类型',
						type: "warning"
					});
					return;
				}
				if(this.returnForm.number.length == 0){
					this.$message({
						message: '您还未开始输入或扫描序列号',
						type: "warning"
					});
				}else{
					this.queryBySerialNumberData();
				}
			},
			inputSerialComform(val){
				if(val.length == 8){
					this.addSerialComformBtn();
				}
			},
			tabRemove (targetName) {
				// 首页不可删除
				if(targetName == '/') {
					return;
				}
				//将该tab从options里移除
				this.$store.commit('delete_tabs', targetName);
				////还同时需要处理一种情况当需要移除的页面为当前激活的页面时，将上一个tab页作为激活tab
				if (this.activeIndex === targetName) {
					// 设置当前激活的路由
					if (this.options && this.options.length >= 1) {
						this.$store.commit('set_active_index', this.options[this.options.length-1].route);
						this.$router.push({path: this.activeIndex});
					} else {
						this.$router.push({path: '/welcome'});
					}
				}
			},
			//已提交
			DetermineSave(){
				if(!this.returnForm.returnType){
					this.$message({
						message: '请选择退料仓库',
						type: "warning"
					});
				}else if(this.returnForm.returnType == 2){
					if(!this.returnForm.residualType){
						this.$message({
							message: '请选择残值类型',
							type: "warning"
						});
					}
				}else if(this.returnData.length == 0){
					this.$message({
						message: '请扫码输入序列号添加物料',
						type: "warning"
					});
				}else if(this.multipleSelection.length == 0){
					this.$message({
						message: '请选择物料再提交',
						type: "warning"
					});
				}else{
					let returnMaterialDetails = [];
					this.multipleSelection.forEach((item,index)=>{
						returnMaterialDetails.push({
							materialCoding:item.materialCoding,
							inventoryCode:item.code,
							materialName:item.materialName,
							modelId:item.modelId,
							modelName:item.modelName,
							belonger:item.engineerId,
							pickTime:item.pickTime,
							orderNo:item.orderNo,
							isRetenRetain:item.isRetenRetain,
							warehouseType:item.warehouseType
						})
					})
					let para = {
						returnType:this.returnForm.returnType,
						sum:this.returnData.length,
						cReturnMaterialDetailsDto:returnMaterialDetails,
					}
					addReturnMaterial(para).then(res => {
						if (res.data.status==100) {
							this.$message({
								message: '提交成功',
								type: "success"
							});
							if (this.pageStatus == '留在当前页面') {
								this.multipleSelection.forEach((item,index)=>{
									this.returnData.forEach((item1,index1)=>{
										if(item.code == item1.code){
											this.returnData.splice(index1,1)
										}
									})
								})
							}else{
								this.tabRemove(this.$route.path);
								this.$router.replace({
									path:'/returnMaterManage'
								});
								this.returnData = [];
							}
						}else{
							this.$message({
								message: res.data.message,
								type: "error"
							});
						}
					}).catch((error) =>{
						this.$Message.error(error.message);
					})
				}
			},
			//暂存
			DetermineSave2(){
				if(!this.returnForm.returnType){
					this.$message({
						message: '请选择退料仓库',
						type: "warning"
					});
				}else if(this.returnForm.returnType == 2){
					if(!this.returnForm.residualType){
						this.$message({
							message: '请选择残值类型',
							type: "warning"
						});
					}
				}else if(this.returnData.length == 0){
					this.$message({
						message: '请扫码输入序列号添加物料',
						type: "warning"
					});
				}else if(this.multipleSelection.length == 0){
					this.$message({
						message: '请选择物料再提交',
						type: "warning"
					});
				}else{
					let returnMaterialDetails = [];
					this.multipleSelection.forEach((item,index)=>{
						returnMaterialDetails.push({
							materialCoding:item.materialCoding,
							inventoryCode:item.code,
							materialName:item.materialName,
							modelId:item.modelId,
							modelName:item.modelName,
							belonger:item.engineerId,
							pickTime:item.pickTime,
							orderNo:item.orderNo,
							isRetenRetain:item.isRetenRetain,
							warehouseType:item.warehouseType
						})
					})
					let para = {
						returnType:this.returnForm.returnType,
						sum:this.returnData.length,
						cReturnMaterialDetailsDto:returnMaterialDetails,
					};
					showLoading();
					returnMaterialSave(para).then(res => {
						hideLoading();
					  if (res.data.status==100) {
							this.$message({
								message: '提交成功',
								type: "success"
							});
							if (this.pageStatus == '留在当前页面') {
								this.multipleSelection.forEach((item,index)=>{
									this.returnData.forEach((item1,index1)=>{
										if(item.code == item1.code){
											this.returnData.splice(index1,1)
										}
									})
								})
							}else{
								this.tabRemove(this.$route.path);
								this.$router.replace({
									path:'/returnMaterManage'
								});
								this.returnData = [];
							}
						}else{
							this.$message({
								message: res.data.message,
								type: "error"
							});
						}
					}).catch((error) =>{
						this.$Message.error(error.message);
					})
				}
			},
			//已提交
			DetermineSave1(){
				if(!this.returnForm.returnType){
					this.$message({
						message: '请选择退料仓库',
						type: "warning"
					});
				}else if(this.returnForm.returnType == 2){
					if(!this.returnForm.residualType){
						this.$message({
							message: '请选择残值类型',
							type: "warning"
						});
					}
				}else if(this.returnData.length == 0){
					this.$message({
						message: '请扫码输入序列号添加物料',
						type: "warning"
					});
				}else if(this.multipleSelection.length == 0){
					this.$message({
						message: '请选择物料再提交',
						type: "warning"
					});
				}else{
					let returnMaterialDetails = [];
					this.multipleSelection.forEach((item,index)=>{
						returnMaterialDetails.push({
							materialCoding:item.materialCoding,
							inventoryCode:item.code,
							materialName:item.materialName,
							modelId:item.modelId,
							modelName:item.modelName,
							belonger:item.engineerId,
							pickTime:item.pickTime,
							orderNo:item.orderNo,
							isRetenRetain:item.isRetenRetain,
							warehouseType:item.warehouseType
						})
					})
					let para = {
						returnType:this.returnForm.returnType,
						sum:this.returnData.length,
						cReturnMaterialDetailsDto:returnMaterialDetails,
						isInFpc:1
					}
					addReturnMaterial(para).then(res => {
						if (res.data.status==100) {
							this.$message({
								message: '提交成功',
								type: "success"
							});
							if (this.pageStatus == '留在当前页面') {
								this.multipleSelection.forEach((item,index)=>{
									this.returnData.forEach((item1,index1)=>{
										if(item.code == item1.code){
											this.returnData.splice(index1,1);
										}
									})
								})
							}else{
								this.tabRemove(this.$route.path);
								this.$router.replace({
									path:'/returnMaterManage'
								})
								this.returnData = [];
							}
						}else{
							this.$message({
								message: res.data.message,
								type: "error"
							});
						}
					}).catch((error) =>{
						this.$Message.error(error.message);
					})
				}
			},
			closeSave(){
				this.pageStatus = "离开当前页面"
			},
			goOnSave(){
				this.pageStatus = "留在当前页面"
			},
			//取消新建
			cancelOrder(){
				this.tabRemove(this.$route.path)
				this.$router.replace({
					path:'/returnMaterManage'
				})
			},
			refresh() {
                this.returnData = [];
                this.totalMoney = 0;
            }
		},
		computed: {
		},
		watch: {

		}
	}
</script>

<style type="text/css" lang="scss">
	#usualNewReturn{
		font-size: 14px;
		.form-item-flex{
			display:flex
		}
		.dialog-content{
			width:900px;
			margin:0 auto;
			.dialog-code-content{
				text-align: center;
				.el-col{
					p{
						border: 1px solid #e3e3e3;
						line-height: 40px
					}
				}
			}
		}
		.totalDiv{
			height: auto;
			overflow: hidden;
			text-align: right;
			font-size: 16px;
			background-color: #fff;
			border-bottom: 1px solid #e5e9f2;
			padding: 10px;
		}
	}
</style>



// WEBPACK FOOTER //
// usualNewReturn.vue?d750cb86